import { createSlice } from '@reduxjs/toolkit'

const firmReportSlice = createSlice({
    name: 'firmReportSlice',
    initialState: {
        startDate: new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + new Date().getDate()).slice(-2) + " 00:00:00",         
        endDate : new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + new Date().getDate()).slice(-2) + " 23:59:59",
        dateSelectChosen : { value: 'selectedDate', label: 'Seçili Tarih' },
        dateVisible : true,
        firmListOptions : [],
        firmListData : [],    
        userEuIdData: [],
        firmReportResponse: {
            customerAccountSummaryReportSMS: [],
            customerAccountOperatorSendTypeReport: [],
            customerAccountSummaryReportMMS: [],
            customerAccountSummaryReportMediaMobile: [],
            firmReport: []
        },    
        smsRows : [],
        typeReportColumns : [],
        typeReportRows : [],
        mmsColumns : [],
        mmsRows : [],
        mediaMobileColumns : [],
        mediaMobileRows : [],
        firmReportColumns : [],
        firmReportRows : [],
        firmListSelectedOptions : [],
        services : ['BULKSMS'],
        message : "",  
        alertType : "",      
    },
    reducers: {
        setStartDate: (state, action) => {
            state.startDate = action.payload;
        },       
        setEndDate: (state, action) => {
            state.endDate = action.payload;
        },  
        setDateSelectChosen: (state, action) => {
            state.dateSelectChosen = action.payload;
        }, 
        setDateVisible: (state, action) => {
            state.dateVisible = action.payload;
        }, 
        setFirmListOptions: (state, action) => {
            state.firmListOptions = action.payload;
        }, 
        setFirmListData: (state, action) => {
            state.firmListData = action.payload;
        },   
        setUserEuIdData: (state, action) => {
            state.userEuIdData = action.payload;
        },   
        setFirmReportResponse: (state, action) => {
            state.firmReportResponse = action.payload;
        },           
        setSmsRows: (state, action) => {
            state.smsRows = action.payload;
        }, 
        setTypeReportRows: (state, action) => {
            state.typeReportRows = action.payload;
        },  
        setMmsRows: (state, action) => {
            state.mmsRows = action.payload;
        },            
        setMediaMobileRows: (state, action) => {
            state.mediaMobileRows = action.payload;
        },  
        setFirmReportRows: (state, action) => {
            state.firmReportRows = action.payload;
        },   
        setFirmListSelectedOptions: (state, action) => {
            state.firmListSelectedOptions = action.payload;
        },   
        setServices: (state, action) => {
            state.services = action.payload;
        },
        setMessage: (state, action) => {
            state.message = action.payload;
        },  
        setAlertType: (state, action) => {
            state.alertType = action.payload;
        }, 
    }
})

export const { setStartDate, setEndDate, setDateSelectChosen, setDateVisible, 
    setFirmListOptions, setFirmListData, setUserEuIdData, setFirmReportResponse,
     setSmsRows, setTypeReportRows,
    setMmsRows, setMediaMobileRows,
    setFirmReportRows, setFirmListSelectedOptions, 
    setServices, setMessage, setAlertType } = firmReportSlice.actions

export default firmReportSlice.reducer